import type {FC} from 'react';
import React from 'react';
import logoPath from "./HEDLogo.svg"

interface HEDLogoProps extends LogoSwitcherProps{
    [key: string]: any;
}

interface LogoSwitcherProps {
    org?: string;
    icon?: boolean;
}

const HEDLogo: FC<HEDLogoProps> = (icon, props) => (
    <img
        alt="HED Logo"
        src={logoPath}
        height={props.icon ? 100 : 64}
        width={props.icon ? 200 : 64}
        style={{
            margin: 1
        }}
        {...props}
    />
);
export default HEDLogo;